"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCustomImages = void 0;

var _reactQuery = require("react-query");

var _map2 = _interopRequireDefault(require("lodash/map"));

var _api = require("../api");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var buildPayload = function buildPayload(toppings) {
  return {
    customImageUUIDs: (0, _map2["default"])(toppings, function (_topping) {
      return {
        uuid: _topping.toppingImage
      };
    })
  };
};

var useCustomImages = function useCustomImages(toppings) {
  var payload = buildPayload(toppings);
  return (0, _reactQuery.useQuery)("CustomImages"
  /* CustomImages */
  , function () {
    return (0, _api.fetchCustomImages)(payload);
  }, {
    enabled: !!payload.customImageUUIDs.length,
    staleTime: 60 * 1000
  });
};

exports.useCustomImages = useCustomImages;